module.exports = __webpack_public_path__ + "img/3.014531b8.jpg";